import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#1A5C4C] text-white/60 py-10 text-center text-sm" data-id="element-36">
        <p className="text-white/80" data-id="element-37">
          © {new Date().getFullYear()} Metabolismo 45+ Reset. Todos los
          derechos reservados.
        </p>
        <p className="mt-2 text-xs max-w-2xl mx-auto px-4" data-id="element-38">
          Este producto no sustituye el consejo médico profesional. Consulte a
          su médico antes de iniciar cualquier programa de alimentación.
        </p>
        <div className="mt-6 flex items-center justify-center gap-6" data-id="element-39">
          <button onClick={() => setActiveModal('privacy')} className="text-white/50 hover:text-white transition-colors underline underline-offset-2" data-id="element-40">
            Política de Privacidad
          </button>
          <span className="text-white/30" data-id="element-41">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-white/50 hover:text-white transition-colors underline underline-offset-2" data-id="element-42">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-43">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-44">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-45">
              {/* Modal Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-[#FDF6F0]" data-id="element-46">
                <h3 className="text-xl font-serif text-[#1A5C4C] font-bold" data-id="element-47">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-[#1A5C4C]/10 transition-colors" aria-label="Cerrar" data-id="element-48">
                  <XIcon className="w-5 h-5 text-[#1A5C4C]" data-id="element-49" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-72px)] text-[#2A2A2A] text-sm leading-relaxed space-y-4" data-id="element-50">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-51" /> : <TermsContent data-id="element-52" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-gray-400" data-id="element-53">Última actualización: marzo 2026</p>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold mt-4" data-id="element-54">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-55">
        Recopilamos únicamente la información que usted nos proporciona
        voluntariamente al realizar una compra, como su nombre, dirección de
        correo electrónico e información de pago. No recopilamos datos de
        navegación ni utilizamos cookies de rastreo de terceros.
      </p>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold" data-id="element-56">
        2. Uso de la Información
      </h4>
      <p data-id="element-57">Su información personal se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-58">
        <li data-id="element-59">Procesar y entregar su compra digital.</li>
        <li data-id="element-60">Enviar confirmaciones de pedido y actualizaciones del producto.</li>
        <li data-id="element-61">Responder a consultas de soporte.</li>
      </ul>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold" data-id="element-62">
        3. Protección de Datos
      </h4>
      <p data-id="element-63">
        Utilizamos cifrado SSL y procesadores de pago seguros para proteger su
        información financiera. No almacenamos datos de tarjetas de crédito en
        nuestros servidores.
      </p>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold" data-id="element-64">
        4. Compartir Información
      </h4>
      <p data-id="element-65">
        No vendemos, alquilamos ni compartimos su información personal con
        terceros, excepto los proveedores de servicios necesarios para procesar
        su compra.
      </p>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold" data-id="element-66">
        5. Sus Derechos
      </h4>
      <p data-id="element-67">
        Usted tiene derecho a solicitar acceso, corrección o eliminación de sus
        datos personales en cualquier momento. Para ejercer estos derechos,
        puede comunicarse con nosotros a través del correo proporcionado en su
        confirmación de compra.
      </p>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold" data-id="element-68">
        6. Cambios a esta Política
      </h4>
      <p data-id="element-69">
        Nos reservamos el derecho de actualizar esta política. Cualquier cambio
        será publicado en esta página con la fecha de actualización
        correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-gray-400" data-id="element-70">Última actualización: marzo 2026</p>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold mt-4" data-id="element-71">
        1. Aceptación de los Términos
      </h4>
      <p data-id="element-72">
        Al adquirir el producto "Metabolismo 45+ Reset", usted acepta estos
        términos y condiciones en su totalidad. Si no está de acuerdo, le
        pedimos que no realice la compra.
      </p>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold" data-id="element-73">
        2. Naturaleza del Producto
      </h4>
      <p data-id="element-74">
        Este es un producto digital educativo en formato PDF. No constituye
        consejo médico, diagnóstico ni tratamiento. Siempre consulte a un
        profesional de la salud antes de iniciar cualquier programa de
        alimentación o ejercicio.
      </p>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold" data-id="element-75">
        3. Entrega del Producto
      </h4>
      <p data-id="element-76">
        El acceso al producto digital se entrega de forma inmediata tras la
        confirmación del pago. Recibirá un enlace de descarga en el correo
        electrónico proporcionado durante la compra.
      </p>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold" data-id="element-77">
        4. Política de Reembolso
      </h4>
      <p data-id="element-78">
        Debido a la naturaleza digital del producto, todas las ventas son
        finales. Sin embargo, si experimenta problemas técnicos con la descarga,
        nos comprometemos a resolverlos de inmediato.
      </p>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold" data-id="element-79">
        5. Propiedad Intelectual
      </h4>
      <p data-id="element-80">
        Todo el contenido del eBook, incluyendo textos, gráficos y metodologías,
        está protegido por derechos de autor. Queda prohibida su reproducción,
        distribución o reventa sin autorización expresa.
      </p>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold" data-id="element-81">
        6. Limitación de Responsabilidad
      </h4>
      <p data-id="element-82">
        Los resultados pueden variar de persona a persona. No garantizamos
        resultados específicos. El uso del protocolo es bajo su propia
        responsabilidad y criterio.
      </p>

      <h4 className="font-serif text-lg text-[#1A5C4C] font-bold" data-id="element-83">
        7. Ley Aplicable
      </h4>
      <p data-id="element-84">
        Estos términos se rigen por las leyes aplicables en el estado de
        residencia del comprador dentro de los Estados Unidos.
      </p>
    </>;
}